import { FullPageSpinner } from "@/components/ui/spinner";

/**
 * Loader Component - Migrated to EDS Spinner
 * 
 * Phase 5: EDS Migration
 * 
 * This component has been migrated from react-loader-spinner (Rings)
 * to the EDS FullPageSpinner component.
 * 
 * Legacy props maintained for backward compatibility:
 * - visible: boolean - Controls whether the loader is shown
 */
function Loader(props) {
  const { visible } = props;
  
  if (!visible) {
    return null;
  }
  
  return <FullPageSpinner size="xl" variant="primary" />;
}

export default Loader;
